module.exports = __webpack_public_path__ + "media/images/1-quart-2cfe8d92420fdf5784b9faca538c5bfd.png";